import { render, staticRenderFns } from "./TelReservation_step2.vue?vue&type=template&id=d5831984&scoped=true"
import script from "./TelReservation_step2.vue?vue&type=script&lang=js"
export * from "./TelReservation_step2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5831984",
  null
  
)

export default component.exports